import React from 'react';
import { TextField, Typography, Grid, Paper } from '@mui/material';
import SearchBarDropdown from '../../SearchBarDropdown';
import {
  SETTING,
  GROUP_SIZE,
  GROUP_TYPE,
  ABSENT_REASON,
  SESSION_TYPES,
} from '../constants/index';

const SessionDetailsCard = ({
  setting,
  customSetting,
  groupSize,
  customGroupSize,
  groupType,
  customGroupType,
  absentReason,
  customAbsentReason,
  sessionType,
  customSessionType,
  onFieldChange,
  sessionAttended = 'Yes',
  sessionTypeHelperText = '',
}) => {
  return (
    <Paper elevation={2} sx={{ p: 3 }}>
      <Typography
        variant='h6'
        sx={{ mb: 2, color: '#9291f0', fontWeight: 600 }}
      >
        Session Details
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <SearchBarDropdown
            options={SETTING}
            value={setting}
            onChange={(selectedValue) =>
              onFieldChange('setting', selectedValue)
            }
            label='Setting'
            sx={{ width: '100%' }}
            message='Select a setting'
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <SearchBarDropdown
            options={GROUP_SIZE}
            value={groupSize}
            onChange={(selectedValue) => {
              onFieldChange('groupSize', selectedValue);
              // Clear customGroupSize if switching away from "Other"
              if (selectedValue !== 'Other') {
                onFieldChange('customGroupSize', '');
              }
            }}
            label='Group Size'
            sx={{ width: '100%' }}
            message='Select a group size'
          />
        </Grid>

        {/* Second Row */}
        <Grid item xs={12} sm={6}>
          <SearchBarDropdown
            options={GROUP_TYPE}
            value={groupType}
            onChange={(selectedValue) =>
              onFieldChange('groupType', selectedValue)
            }
            label='Group Type'
            sx={{ width: '100%' }}
            message='Select a group type'
          />
        </Grid>

        {sessionAttended === 'No' && (
          <Grid item xs={12} sm={6}>
            <SearchBarDropdown
              options={ABSENT_REASON}
              value={absentReason}
              onChange={(selectedValue) =>
                onFieldChange('absentReason', selectedValue)
              }
              label='Absent Reason'
              sx={{ width: '100%' }}
              message='Select an absent reason'
            />
          </Grid>
        )}

        {/* Third Row */}
        <Grid item xs={12} sm={6}>
          <SearchBarDropdown
            options={SESSION_TYPES}
            value={sessionType}

            onChange={(selectedValue) =>
              onFieldChange('sessionType', selectedValue)
            }
            label='Session Type'
            sx={{ width: '100%' }}
            message='Select a session type'
          />
          {sessionTypeHelperText ? (
            <Typography
              variant='caption'
              color='text.secondary'
              sx={{ display: 'block', mt: 0.5 }}
            >
              {sessionTypeHelperText}
            </Typography>
          ) : null}
        </Grid>

        {/* Conditional Fields */}
        {setting === 'Other' && (
          <Grid item xs={12}>
            <TextField
              label='Custom Setting'
              fullWidth
              value={customSetting || ''}
              onChange={(e) => onFieldChange('customSetting', e.target.value)}
              placeholder='Enter setting'
              variant='outlined'
              sx={{ backgroundColor: '#f9f9ff' }}
            />
          </Grid>
        )}

        {groupSize === 'Other' && (
          <Grid item xs={12}>
            <TextField
              label='Group Size'
              type='number'
              fullWidth
              value={customGroupSize || ''}
              onChange={(e) => {
                const value = e.target.value;
                onFieldChange('customGroupSize', value);
              }}
              placeholder='Enter number of people'
              variant='outlined'
              inputProps={{ min: 1 }}
              sx={{ backgroundColor: '#f9f9ff' }}
              helperText='Enter the number of people in the group'
            />
          </Grid>
        )}

        {groupType === 'Other' && (
          <Grid item xs={12}>
            <TextField
              label='Custom Group Type'
              fullWidth
              value={customGroupType || ''}
              onChange={(e) => onFieldChange('customGroupType', e.target.value)}
              placeholder='Enter group type'
              variant='outlined'
              sx={{ backgroundColor: '#f9f9ff' }}
            />
          </Grid>
        )}

        {absentReason === 'Other' && (
          <Grid item xs={12}>
            <TextField
              label='Custom Absent Reason'
              fullWidth
              value={customAbsentReason || ''}
              onChange={(e) =>
                onFieldChange('customAbsentReason', e.target.value)
              }
              placeholder='Enter absent reason'
              variant='outlined'
              sx={{ backgroundColor: '#f9f9ff' }}
            />
          </Grid>
        )}

        {sessionType === 'Other' && (
          <Grid item xs={12}>
            <TextField
              label='Custom Session Type'
              fullWidth
              value={customSessionType || ''}
              onChange={(e) =>
                onFieldChange('customSessionType', e.target.value)
              }
              placeholder='Enter session type'
              variant='outlined'
              sx={{ backgroundColor: '#f9f9ff' }}
            />
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

export default SessionDetailsCard;
